// extracted by mini-css-extract-plugin
module.exports = {"avatar":"styles__avatar___1f9lh"};